exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.congrats[data-v-29475dc2] {\n  width: 100%;\n  max-width: 520px;\n  padding: 15px;\n  padding-top: 50px;\n}\n@media (max-width: 400px) {\n.congrats[data-v-29475dc2] {\n    font-size: 12px;\n}\n.congrats img[data-v-29475dc2] {\n    width: 50%;\n}\n.congrats .w-100[data-v-29475dc2] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.congrats .w-100 button[data-v-29475dc2] {\n    width: 90%;\n    margin: 8px 0;\n}\n}\n", ""]);

// exports
